import { render } from "./PlaceholderView.vue?vue&type=template&id=8a377a06&scoped=true&ts=true"
import script from "./PlaceholderView.vue?vue&type=script&lang=ts"
export * from "./PlaceholderView.vue?vue&type=script&lang=ts"

import "./PlaceholderView.vue?vue&type=style&index=0&id=8a377a06&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a377a06"]])

export default __exports__